// src/components/AdminDashboard.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import Switch from 'react-switch';
import '../styles/AdminDashboard.css';
import BackgroundShader from './BackgroundShader';

const AdminDashboard = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [menus, setMenus] = useState([]);
  const [filteredMenus, setFilteredMenus] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [categories, setCategories] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [newMenu, setNewMenu] = useState({
    name: '',
    description: '',
    price: '',
    category_id: '',
    iSmenu_du_jour:'false'
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const menusRes = await axios.get(`${BASE_URL}/ilrialto/menus`);
        setMenus(menusRes.data);
        setFilteredMenus(menusRes.data);
        const categoriesRes = await axios.get(`${BASE_URL}/ilrialto/categories`);
        setCategories(categoriesRes.data);
      } catch (err) {
        console.error('Erreur chargement:', err);
      }
    };
    fetchData();
  }, [menus]);

  useEffect(() => {
    const lowerSearch = searchTerm.toLowerCase();
    const filtered = menus.filter(menu => {
      const name = menu.name ? menu.name.toLowerCase() : '';
      const description = menu.description ? menu.description.toLowerCase() : '';
      return (
        (!categoryFilter || String(menu.category_id) === String(categoryFilter)) &&
        (name.includes(lowerSearch) || description.includes(lowerSearch))
      );
    });
    setFilteredMenus(filtered);
  }, [menus, searchTerm, categoryFilter]);

  const handleAddMenu = async () => {
    const formData = new FormData();
    Object.entries(newMenu).forEach(([key, value]) => formData.append(key, value));
    console.log('newMenu', newMenu);
    if (imageFile) formData.append('image', imageFile);
    try {
      const res = await axios.post(`${BASE_URL}/ilrialto/menus`, formData);
      setMenus([...menus, res.data]);
      handleCloseModal();
    } catch (err) {
      console.error('Erreur ajout:', err);
    }
  };

  const handleUpdateMenu = async () => {
    const formData = new FormData();
    Object.entries(newMenu).forEach(([key, value]) => formData.append(key, value));
    console.log('newUPDATEMenu', newMenu);
    if (imageFile) {
      formData.append('image', imageFile);
    } else {
      formData.append('image_url', selectedMenu.image_url);
    }

    try {
      const res = await axios.put(`${BASE_URL}/ilrialto/menus/${selectedMenu.id}`, formData);
      setMenus(menus.map((m) => (m.id === selectedMenu.id ? res.data : m)));
      handleCloseModal();
    } catch (err) {
      console.error('Erreur maj:', err);
    }
  };

  const handleDeleteMenu = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/ilrialto/menus/${id}`);
      setMenus(menus.filter((m) => m.id !== id));
    } catch (err) {
      console.error('Erreur suppression:', err);
    }
  };

/*   const handleToggleMenuDuJour = async (menu, checked) => {
    try {
      const updatedMenu = { ...menu, iSmenu_du_jour: checked };
      const formData = new FormData();
      Object.entries(updatedMenu).forEach(([key, value]) => formData.append(key, value));
      formData.append('image_url', menu.image_url);
      await axios.put(`${BASE_URL}/ilrialto/menus/${menu.id}`, formData);
      setMenus(menus.map((m) => (m.id === menu.id ? { ...m, iSmenu_du_jour: checked } : m)));
    } catch (err) {
      console.error("Erreur mise à jour menu du jour:", err);
    }
  }; */

  const handleEditMenu = (menu) => {
    setSelectedMenu(menu);
   
    setNewMenu({
      name: menu.name,
      description: menu.description,
      price: menu.price,
      category_id: menu.category_id,
      iSmenu_du_jour: menu.iSmenu_du_jour
    });
    setImageFile(null);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMenu(null);
    setNewMenu({ name: '', description: '', price: '', category_id: '', iSmenu_du_jour: false });
    setImageFile(null);
  };

  return (
    <div className="admin-dashboard">
      <BackgroundShader/>
      <h1>Gestion des Menus</h1>

      <div className="filters">
        <input
          type="text"
          placeholder="Rechercher un plat..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
          <option value="">Toutes les catégories</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>{cat.name}</option>
          ))}
        </select>
      </div>

      <div className="menu-grid">
        {filteredMenus.map((menu) => (
          <div key={menu.id} className="menu-card">
            <img src={menu.image_url} alt={menu.name} className="menu-thumb" />
            <div className="menu-info">
              <h3>{menu.name}</h3>
              <p>{menu.description}</p>
              <span className="price">{menu.price} €</span>
              <span className="category">{menu.category_name}</span>
            </div>
            <div className="menu-actions">
              <button onClick={() => handleEditMenu(menu)} title="Modifier">
                <FontAwesomeIcon icon={faEdit} />
              </button>
              {menu.iSmenu_du_jour ? (
              <span className="status on">ON</span>
                   ) : (
              <span className="status off">OFF</span>
                )}
              <button onClick={() => handleDeleteMenu(menu.id)} title="Supprimer">
                <FontAwesomeIcon icon={faTrash} />
              </button>
              
            </div>
          </div>
        ))}
      </div>

      <button className="add-btn" onClick={() => setShowModal(true)}>
        <FontAwesomeIcon icon={faPlus} /> Ajouter un Menu
      </button>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedMenu ? 'Modifier' : 'Ajouter'} un Menu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            placeholder="Nom"
            value={newMenu.name}
            onChange={(e) => setNewMenu({ ...newMenu, name: e.target.value })}
          />
          <textarea
            placeholder="Description"
            value={newMenu.description}
            onChange={(e) => setNewMenu({ ...newMenu, description: e.target.value })}
          />
          <input
            type="text"
            placeholder="Prix"
            value={newMenu.price}
            onChange={(e) => setNewMenu({ ...newMenu, price: e.target.value })}
          />
          <select
            value={newMenu.category_id}
            onChange={(e) => setNewMenu({ ...newMenu, category_id: e.target.value })}
          >
            <option value="">Catégorie</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
          <Form.Check
            type="switch"
            label="Menu du jour"
            checked={newMenu.iSmenu_du_jour}
            onChange={(e) => setNewMenu({ ...newMenu, iSmenu_du_jour: e.target.checked })}
          />
          {selectedMenu && selectedMenu.image_url && !imageFile && (
            <img
              src={selectedMenu.image_url}
              alt="Aperçu"
              className="img-preview"
              style={{ width: '100%', height: 'auto', marginBottom: '10px', borderRadius: '6px' }}
            />
          )}
          <input type="file" onChange={(e) => setImageFile(e.target.files[0])} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Annuler
          </Button>
          <Button variant="primary" onClick={selectedMenu ? handleUpdateMenu : handleAddMenu}>
            {selectedMenu ? 'Mettre à jour' : 'Ajouter'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminDashboard;
